import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store/store';
import { BASE_URL } from 'app/utils/utils';
import { onQueryStartedErrorToast } from './apiErrorHandler';

export const authApi = createApi({
  reducerPath: 'auth',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL + '/auth/versions/1/',
    credentials: 'include',
    mode: 'cors',
    prepareHeaders: (headers: Headers, { getState }) => {
      const user = (getState() as RootState).userSlice;
      if (user.auth) {
        headers.set('x-ais-user-csrf', user.auth.value.csrfToken);
        headers.set('ais-user-csrf', user.auth.value.csrfToken);
      }
      return headers;
    },
  }),
  tagTypes: ['Auth'],
  endpoints: (build) => ({
    startLogin: build.mutation<any, any>({
      query: () => ({
        url: 'login/start',
        method: 'POST',
        withCredentials: true,
      }),
      onQueryStarted: onQueryStartedErrorToast,
      invalidatesTags: ['Auth'],
    }),
    userCheck: build.mutation<any, string>({
      query: (url: string) => ({
        url: 'login/end',
        method: 'POST',
        body: { pageUrl: url },
        withCredentials: true,
      }),
      onQueryStarted: onQueryStartedErrorToast,
      invalidatesTags: ['Auth'],
    }),
    logout: build.mutation({
      query: () => ({
        url: 'logout',
        method: 'POST',
        withCredentials: true,
      }),
      onQueryStarted: onQueryStartedErrorToast,
      invalidatesTags: ['Auth'],
    }),
  }),
});

export const { useStartLoginMutation, useUserCheckMutation, useLogoutMutation } = authApi;
